import type { SelectProps } from "@mui/material";
import { Select, Tooltip } from "@mui/material";
import classNames from "classnames";
import { forwardRef } from "react";

import variables from "../../../assets/styles/_variables.module.scss";
import styles from "./style.module.scss";

const selectStyle = {
    "&.MuiOutlinedInput-root": {
        fontFamily: "inherit",
        fontSize: "14px",
        "& > fieldset": {
            borderRadius: variables["border-radius"],
            borderColor: `${variables["border-grey"]} !important`,
        },
        "&:hover": {
            "& > fieldset": {
                borderColor: variables["secondary-purple"],
            },
        },
        "&.Mui-focused": {
            fieldset: {
                borderColor: variables["primary-purple"],
            },
        },
        "&.Mui-error": {
            backgroundColor: "#FCEFF3",
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: "#9B5067",
            },
        },
        "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            paddingBlock: "8.5px",
            fontSize: "14px",
        },
    },
};

type StyledSelectProps = {
    /**
     * True when options are buttons (like Payment status)
     */
    buttonType?: boolean;
    /**
     * If true, removes gradient border. False by default.
     */
    noGradient?: boolean;
    tooltipText?: string;
} & SelectProps;

const StyledSelect = forwardRef<any, StyledSelectProps>(function StyledSelect(props: StyledSelectProps, ref) {
    const { sx, buttonType = false, noGradient = false, tooltipText = "", MenuProps: menuProps, ...rest } = props;
    const callerPaperSx = menuProps?.PaperProps?.sx;
    const paperSx =
        callerPaperSx && typeof callerPaperSx === "object" && !Array.isArray(callerPaperSx)
            ? { maxHeight: "300px", ...callerPaperSx }
            : { maxHeight: "300px" };

    return (
        <Tooltip title={tooltipText} arrow>
            <Select
                {...rest}
                ref={ref}
                MenuProps={{
                    ...menuProps,
                    PaperProps: {
                        ...menuProps?.PaperProps,
                        sx: paperSx,
                        className: classNames(
                            {
                                [styles["styled-select"]]: true,
                                [styles["gradient"]]: !noGradient,
                            },
                            menuProps?.PaperProps?.className,
                        ),
                    },
                    MenuListProps: {
                        ...menuProps?.MenuListProps,
                        className: classNames(
                            {
                                [styles["select-list"]]: true,
                                [styles["button-type"]]: buttonType,
                            },
                            menuProps?.MenuListProps?.className,
                        ),
                    },
                }}
                sx={{ ...selectStyle, ...sx }}
            />
        </Tooltip>
    );
});

export default StyledSelect;
